import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtestadosComponent } from './atestados.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { AtestadosRoutingModule } from './atestados-routing.module';
import { ModalComponent } from './components/modal/modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';


const components = [AtestadosComponent, ModalComponent,];

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AtestadosRoutingModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    MatRadioModule,
  ],
  declarations: [...components]
})
export class AtestadosModule { }
